// TODO: This is potentially temporary, in order to be able to get away from the mixin but still keep some way to
//  annotate props on it used to be used, at least until we decide where should we initialize content for them.
export default {
  props: {
    defaultView: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    viewApplication: {
      type: String,
      required: true,
    },
    propertyOption: {
      type: Object,
      default: () => null,
    },
    planning: {
      type: Object,
      default: () => null,
    },
  },
};
